<template>
    <div>
        {{ userName }}

        {{ action }}

        <template v-if="event.action == 'media_deleted'">
            <template v-if="Object.keys(event.data).length > 1"> {{ Object.keys(event.data).length }} {{ $t('files') }}</template>
            <template v-else>{{ $t('aFile') }}</template>
        </template>

        <template v-if="event.action == 'media_uploaded'">
            <template v-if="event.data.uploaded.length > 1"> {{ event.data.uploaded.length }} {{ $t('files') }}</template>
            <template v-else>{{ $t('aFile') }}</template>
        </template>

        <template v-if="event.action == 'media_dir_deleted'">
            <i> {{ event.data.path.split("/")[1] }} </i>
        </template>

        <template v-if="event.action == 'media_deleted' || event.action == 'media_dir_deleted'">
          {{ $t('from') }}
        </template>

        <template v-else> {{ $t('to') }} </template>
      {{ $t('mediaLibrary') }}
    </div>
</template>

<script>
import Pluralize from 'pluralize'

export default {
    name: "Event",
    props: {
        event: {
            type: Object
        }
    },
    data: function() {
        return {
            events: {
                media_deleted: "deleted",
                media_uploaded: "uploaded",
                media_dir_deleted: "deleted dir"
            }
        }
    },
    computed: {
        action() {
            return this.events[this.event.action]
        },

        userName() {
            let user = this.$store.getters.getUser
            return user.uuid == this.event.user.uuid ? "You" : this.event.user.name
        }
    },
    methods: {
        pluralize(val) {
            return Pluralize(val)
        }
    }
}
</script>
